
import React, { Component } from 'react';
import { connect } from 'react-redux';
//import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//comopnents:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getPromocionList, modifyPromocion, removePromocion, addPromocion, updatePromocionListDB } from '../../actions/promocion_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    }, formControl: {
        marginLeft: '10px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresPromocion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            centroId: this.props.centroId ? this.props.centroId : undefined,
        };

    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getPromocionList(this.state.centroId ? this.state.centroId : -1);

    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkPromocion = (promocion) => {
        if (this.props.promocionList.find(c => (c.descr === promocion.descr) && (c.id !== promocion.id))) {
            this.messageDialog(`Ya existe una promocion con descripción ${promocion.descr}`);
            return false;
        } else if (!promocion.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        } else if (parseInt(promocion.puntosFijos) < 0) {
            this.messageDialog('Los puntos fijos deben ser positivos');
            return false;
        } else if (parseFloat(promocion.puntosPorEuro) < 0.0) {
            this.messageDialog('Los puntos por euro deben ser positivos');
            return false;
        } else if ((!promocion.puntosFijos || parseInt(promocion.puntosFijos) === 0) &&
            (!promocion.puntosPorEuro || parseFloat(promocion.puntosPorEuro) === 0.0)) {
            this.messageDialog('Ambos puntos no pueden ser cero');
            return false;
        }

        else return true;
    };

    addNewPromocion = (promocion) => {
        this.props.setSaveState(true);
        this.props.addPromocion(promocion);
    };

    newPromocion = () => {
        if (this.state.centroId !== undefined && this.state.centroId !== 10 && this.state.centroId !== -1) {
            this.props.openDialog('EditPromocion', {
                promocion: {},
                okHandler: this.addNewPromocion,
                checkPromocion: this.checkPromocion,
                centroId: this.state.centroId
            }, uuidv4());

        }
        else {
            this.messageDialog('Debe escoger un centro antes de crear una promoción');
        }
    };


    editPromocion = (promocion) => {

        this.props.openDialog('EditPromocion', {
            promocion: promocion,
            checkPromocion: this.checkPromocion,
            okHandler: (sf) => {
                this.props.setSaveState(true);
                this.props.modifyPromocion(sf);
            },
            centroId: this.state.centroId,
            userId: this.props.user.id,

        }, uuidv4());
    };

    handleDeleteRow = (promocion) => {
        this.props.setSaveState(true);
        this.props.removePromocion(promocion);
    };

    // ddw centros events
    centroSelectList = () => {

        return this.props.centros.filter(c => c.isGroup === false && c.activo === 1).map((centro, index) => {
            return (
                <option key={centro.id} value={centro.id}>{centro.centro}</option>
            );
        })
    };

    handleChangeSelect = event => {

        const c_id = event.target.value ? event.target.value : 1;
        this.setState({ ...this.state, centroId: c_id });
        this.props.getPromocionList(event.target.value ? event.target.value : 1);
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div style={{ marginBottom: 20 }}>

                    {this.props.centros ?
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="promocion-placeholder">
                                Centro
                            </InputLabel>
                            <Select
                                native
                                value={this.props.centroId}
                                onChange={(event) => this.handleChangeSelect(event)}
                            >
                                {this.props.centros.find(c => c.id === this.props.centroId) === undefined ? <option key={'centro_0'} value={0}>{"Seleccione un centro"}</option> : ''}
                                {this.centroSelectList()}
                            </Select>
                        </FormControl>
                        : ''}

                    <NeuriteGrid
                        id="m_r_p"
                        columns={[
                            { key: 'descr', name: 'Descripción', editable: false, dragable: false, width: 150 },
                            { key: 'tipoPromocionDescr', name: 'Tipo', tooltip: 'Tipo de promoción', editable: false, dragable: false, width: 80 },
                            { key: 'puntosPorEuro', name: 'Puntos/€', tooltip: 'Puntos asignados por cada euro', type: 'float', editable: false, dragable: false, width: 65 },
                            { key: 'puntosFijos', name: 'Puntos', tooltip: 'Puntos fijos asignados', type: 'int', editable: false, dragable: false, width: 65 },
                            { key: 'fAlta', name: 'Fecha alta', tooltip: 'Fecha de alta de la promoción', type: 'date', editable: false, dragable: false, width: 80 },
                            { key: 'activa', name: 'Activo', type: 'bool', editable: false, dragable: false, width: 55 },
                            { key: 'obsv', name: 'Observaciones', editable: false, dragable: false, width: 200 },
                        ]}
                        rows={this.props.promocionList}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newPromocion}
                        // onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        onEditClick={this.editPromocion}
                    />
                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.promocionList.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updatePromocionListDB(this.props.promocionList, this.state.centroId)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresPromocion.propTypes = {
    //state
    promocionList: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getPromocionList: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyPromocion: PropTypes.func.isRequired,
    removePromocion: PropTypes.func.isRequired,
    addPromocion: PropTypes.func.isRequired,
    updatePromocionListDB: PropTypes.func.isRequired,
    // user ddw
    centros: PropTypes.array.isRequired,
    centroId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        promocionList: state.promocion.promocionList,

        user: state.oidc.user,
        centros: state.centros.centros,
        centroId: state.promocion.centroId
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getPromocionList,
        openDialog,
        hideDialog,
        modifyPromocion,
        removePromocion,
        addPromocion,
        updatePromocionListDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresPromocion));